import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Open16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M6.84505 2.95052H2.95052V13.0495H13.0495V9.15495C13.0495 8.7544 13.3742 8.42969 13.7747 8.42969C14.1753 8.42969 14.5 8.7544 14.5 9.15495V13.2375C14.5 13.9348 13.9348 14.5 13.2375 14.5H2.76249C2.06524 14.5 1.5 13.9348 1.5 13.2375V2.76249C1.5 2.06524 2.06524 1.5 2.76249 1.5H6.84505C7.2456 1.5 7.57031 1.82471 7.57031 2.22526C7.57031 2.62581 7.2456 2.95052 6.84505 2.95052Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.3017 1.72693C14.3626 1.79124 14.4094 1.86398 14.4423 1.94125C14.4794 2.02847 14.5 2.12447 14.5 2.22526V5.6901C14.5 6.09065 14.1753 6.41537 13.7747 6.41537C13.3742 6.41537 13.0495 6.09065 13.0495 5.6901V3.97619L7.35787 9.66778C7.07464 9.95102 6.61543 9.95102 6.3322 9.66778C6.04897 9.38455 6.04897 8.92534 6.3322 8.64211L12.0238 2.95052H10.3099C9.90933 2.95052 9.58462 2.62581 9.58462 2.22526C9.58462 1.82471 9.90933 1.5 10.3099 1.5H13.7746C13.9676 1.5 14.1431 1.57538 14.2731 1.69831C14.2829 1.70759 14.2924 1.71713 14.3017 1.72693Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
